export const TOGGLE_SEARCH = "TOGGLE_SEARCH";

export const toggleSearch = (searchIsActive) => ({
  type: TOGGLE_SEARCH,
  searchIsActive,
});
